import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const ContactUsPage = () => (
  <div className="legal-page">
    <div className="legal-container">
      <Link to="/" className="legal-back-link">← Back to Home</Link>

      <div className="legal-header">
        <span className="legal-eyebrow">Support</span>
        <h1 className="legal-title">Contact Us</h1>
        <p className="legal-updated">Last updated: 18 March 2026</p>
      </div>

      <div className="legal-body">
        <p>
          <strong>CodeHub (Batos IT Solutions LLP)</strong> provides support for all platform-related queries,
          including payments, refunds, cancellations, internship access, certificates, and related services.
          Users can reach out to us using the details below.
        </p>

        <h2>Registered Address</h2>
        <p>
          Sterling Towers, Level 1, 2 & 3, Pan Card Club Road, Baner, Pune 411045, Maharashtra, India
        </p>

        <h2>Email</h2>
        <p>
          <a href="mailto:connect@batosit.com">connect@batosit.com</a><br />
          <a href="mailto:support@batosit.com">support@batosit.com</a>
        </p>

        <h2>Phone</h2>
        <p>
          <a href="tel:+918261888035">+91-82618 88035</a> (Primary)<br />
          <a href="tel:+919423885741">+91-9423885741</a> (Secondary)
        </p>

        <h2>Support Hours</h2>
        <p>
          Monday to Saturday, 10:00 AM – 6:00 PM
        </p>

        <div className="legal-info">
          <strong>Support Topics:</strong> Payments, refunds, cancellations, internship access, project submissions,
          certificates, account issues, and general platform support.
        </div>

        <div className="legal-contact">
          <h3>CodeHub — Batos IT Solutions LLP</h3>
          <p>
            Sterling Towers, Level 1, 2 & 3, Pan Card Club Road, Baner, Pune 411045, Maharashtra, India<br />
            Email: <a href="mailto:connect@batosit.com">connect@batosit.com</a> / <a href="mailto:support@batosit.com">support@batosit.com</a><br />
            Phone: <a href="tel:+918261888035">+91-82618 88035</a> (Primary) / <a href="tel:+919423885741">+91-9423885741</a> (Secondary)<br />
            Support Hours: Monday to Saturday, 10:00 AM – 6:00 PM<br />
            Website: <a href="https://www.codehub.batosit.com">www.codehub.batosit.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ContactUsPage;